<template>
  <div>
    <div v-if="none">
      <p>No {{groupName}} recorded.</p>
    </div>
    <div v-else>
      <div v-for="e in entries" v-bind:key="e">
        <h4>{{groupName + ' ' + e}}</h4>
        <div v-for="i in indexes" v-bind:key="i">
          <QuestionReview :q="createDisplayQuestion(i, e)" />
        </div>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionReview from './QuestionReview.vue'
export default {
  props:{
    questions: Array,
    indexes: Array
  },
  components:{
    QuestionReview
  },
  data(){
    return{
      none: false,
      entries: null,
      groupName: null
    }
  },
  mounted() {
    if (this.$props.questions[this.$props.indexes[0]].answer.value.length === 0) {
      this.none = true
    } else {
      this.entries = this.$props.questions[this.$props.indexes[0]].answer.value.length - 1
    }
    this.getGroupName()
  },
  methods:{
    getGroupName(){
      var name = this.$props.questions[this.$props.indexes[0]].repeat_group
      name = name.replace(/_/g, " ")
      name = name.split(" ")
      for (var i = 0, x = name.length; i < x; i++) {
        name[i] = name[i][0].toUpperCase() + name[i].substr(1)
      }
      this.groupName = name.join(" ")
    },
    createDisplayQuestion(i, entry) {
      var question = {}
      question['question_type'] = this.$props.questions[i].question_type
      question['answer'] = this.$props.questions[i].answer.value[entry]
      question['prompt'] = this.$props.questions[i].prompt
      return question
    }
  }
}
</script>

<style lang="scss" scoped>

H4 {
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-size: 20px;
  color: #1B86B5;
  font-weight: 600;
}

</style>
